import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BasicDetails from "./BasicDetails";
import OrgImg from "./OrgImg";
import SupportDetails from "./SupportDetails";
import { AlertBox, alertTypes, SNETButton } from "shared/dist/components";
import ValidationError from "shared/dist/utils/validationError";
import validator from "shared/dist/utils/validator";
import { orgProfileValidationConstraints, contactConstraints } from "./validationConstraints";
import { ContactsTypes } from "../../../Utils/Contacts";
import { isEmpty, isUndefined } from "lodash";
import { storageProviders } from "../../../Utils/storageTypes";
import classes from "./OrganizationProfile.module.css";
import { useFinishLater } from "..";
import { useNavigateTo } from "../../../GlobalRouter/hook/NavigateTo";
import { REGION } from "../Routes";
import FormContentCard from "../../../Components/PageFormComponents/FormContentCard";
import FormActions from "../../../Components/PageFormComponents/FormActions";

const OrganizationProfile = () => {
    const navigateTo = useNavigateTo();
    const { handleFinishLater } = useFinishLater();
    const organization = useSelector((state) => state.organization);
    const [alert, setAlert] = useState({});
    const [isDisableContinueButton, setIsDisableContinueButton] = useState(false);

    useEffect(() => {
        const isFormInvalid = () => {
            const invalidOrganizationData = validator(
                organization,
                orgProfileValidationConstraints,
                {
                    format: "flat",
                }
            );
            const supportContacts = organization.contacts.find(
                (el) => el.type === ContactsTypes.SUPPORT
            );
            let invalidSupportOrganizationData;
            if (supportContacts.phone) {
                invalidSupportOrganizationData = validator(supportContacts, contactConstraints, {
                    format: "flat",
                });
            } else {
                invalidSupportOrganizationData = validator(
                    supportContacts.email,
                    contactConstraints.email,
                    {
                        format: "flat",
                    }
                );
            }
            const isAvatarValid =
                !organization.assets.heroImage.raw && !organization.assets.heroImage.url;

            const isFilecoinTokenExist =
                organization.storageProvider !== storageProviders.FILECOIN ||
                !isEmpty(organization.lighthouseToken);

            return (
                !isUndefined(invalidSupportOrganizationData) ||
                !isUndefined(invalidOrganizationData) ||
                isAvatarValid ||
                !isFilecoinTokenExist
            );
        };

        setIsDisableContinueButton(isFormInvalid());
    }, [organization]);

    const handleContinue = () => {
        navigateTo.organizationSetup({ orgUuid: organization.uuid }, REGION.path);
    };

    const onFinishLater = async () => {
        try {
            setAlert({});
            await handleFinishLater();
            setAlert({ type: alertTypes.SUCCESS, message: "Changes have been saved to draft" });
        } catch (error) {
            const errorMessage =
                error instanceof ValidationError
                    ? error.message
                    : "Unable to save draft. Please try later";
            setAlert({ type: alertTypes.ERROR, message: errorMessage });
        }
    };

    return (
        <Fragment>
            <FormContentCard title="Organization Profile">
                <BasicDetails />
                <hr />
                <OrgImg />
                <hr />
                <SupportDetails />
                {alert.message && (
                    <div className={classes.errorContainer}>
                        <AlertBox
                            type={alert.type}
                            message={alert.message}
                            children={alert.children}
                        />
                    </div>
                )}
            </FormContentCard>
            <FormActions>
                <SNETButton color="primary" children="finish later" onClick={onFinishLater} />
                <SNETButton
                    color="primary"
                    variant="contained"
                    children="continue"
                    disabled={isDisableContinueButton}
                    onClick={handleContinue}
                />
            </FormActions>
        </Fragment>
    );
};

export default OrganizationProfile;
